import React, { useEffect, useState } from 'react';
import { spacing } from '../../constants/styles.constants';
import { Column, Container, Row } from '../../components/Layout';
import TrailsList from "../../components/TrailList";
import Loading from "../../components/Loading";
import LogoHeading from "../../components/LogoHeading";
import { useGlobalState } from "../../hooks/useGlobalState";
import { genericRequest, genericTrailsRequest } from "../../utils/request";

// eslint-disable-next-line
export default () => {
    const [{ trailList }, { setTrailList }] = useGlobalState();
    const [userData, setUserData] = useState({});
    const [trailListFilterData, setTrailListFilterData] = useState([]);
    const [requestStatus, setRequestStatus] = useState({
        isError: false,
        isLoading: false,
        isSuccess: false
    });
    const [requestUserDataStatus, setRequestUserDataStatus] = useState({
        isError: false, isLoading: false, isSuccess: false,
    });

    useEffect(() => {
        async function getUserData() {
            setRequestUserDataStatus({ isLoading: true });
            const request = await genericRequest({
                endpoint: 'getUserDetails',
                method: 'GET',
            });

            if (request.response) {
                setUserData(request.response.data);
                return setRequestUserDataStatus({ isSuccess: true });
            }

            return setRequestUserDataStatus({ isError: request.error });
        }

        async function getTrailsData() {
            setRequestStatus({ isLoading: true });
            const request = await genericTrailsRequest({ endpoint: 'user/trails' });

            if (request.response) {
                setTrailList({ data: request.response.data });
                setTrailListFilterData(request.response.data);
                return setRequestStatus({ isSuccess: true });
            }

            return setRequestStatus({ isError: request.error });
        }

        getUserData().then()
        getTrailsData().then()
    }, [setRequestStatus, setTrailList, setRequestUserDataStatus, setUserData]);

    const trailsListFilter = (event) => {
        const searchTerm = event.target.value
        setTrailListFilterData(trailList.filter(el => el.title.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1));
    }

    return (
        <Container>
            <LogoHeading/>
            <Loading isLoading={requestStatus.isLoading || requestUserDataStatus.isLoading}
                     isError={requestStatus.isError || requestUserDataStatus.isError}
                     isSuccess={requestStatus.isSuccess && requestUserDataStatus.isSuccess}
                     errorMessage={"We Couldn't List Trails At This Time"}
                     successMessage={"We got the Trails List"}
            >
                <Row space={spacing.large}>
                    <Column space={spacing.large}>
                        <TrailsList
                            trailList={trailListFilterData}
                            trailListFilter={trailsListFilter}
                            userData={userData}
                        />
                    </Column>
                </Row>
            </Loading>
        </Container>
    );
};
